<script setup>
import { useI18n } from 'vue-i18n';
import EmphasizeImage from '@/components/preview/kakao/alimtalk/EmphasizeImage.vue';
import EmphasizeText from '@/components/preview/kakao/alimtalk/EmphasizeText.vue';
import EmphasizeItemList from '@/components/preview/kakao/alimtalk/EmphasizeItemList.vue';
import HeaderSection from '@/components/preview/kakao/alimtalk/HeaderSection.vue';

defineProps({
  kakaoProfile: {
    type: String,
    default: '',
  },
  alimtalkTemplateData: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

defineOptions({
  inheritAttrs: false,
});

</script>
<template>
  <div class="preview-talk preview-talk--active">
    <div class="preview-inner mockup-scroll">
      <HeaderSection :kakao-profile="kakaoProfile" />
      <div class="preview-message preview-message--active">
        <div class="preview-message__top">
          {{ t('alimtalk.preview.head') }}
          <div class="preview-message__kakao-label">
              <span>kakao</span>
          </div>
        </div>
        <EmphasizeImage
          :emphasize-type="alimtalkTemplateData.emphasizeType"
          :image="alimtalkTemplateData.image"
        />
        <div class="preview-message__inner">
          <EmphasizeText
            :emphasize-type="alimtalkTemplateData.emphasizeType"
            :title="alimtalkTemplateData.title"
            :sub-title="alimtalkTemplateData.subTitle"
          />
          <EmphasizeItemList
            :emphasize-type="alimtalkTemplateData.emphasizeType"
            :item-list="alimtalkTemplateData.itemList?.list"
            :header="alimtalkTemplateData.header"
            :highlight="alimtalkTemplateData.itemHighlight"
            :summary="alimtalkTemplateData.itemList?.summary"
          />
          <div class="preview-message__inner-cont">
            <pre>{{ alimtalkTemplateData.content }}</pre>
          </div>
          <div
            class="preview-message__inner-cont add"
            :class="{ 'd-none': !alimtalkTemplateData.extra }"
          >
            <pre>{{ alimtalkTemplateData.extra }}</pre>
          </div>
        </div>
        <div class="preview-message__button">
          <button
            v-for="(item, index) in alimtalkTemplateData.buttons"
            :key="`wideItemList-preview-button${index}`"
            :class="{
              'preview-message__button--kakao': item.type === 'AC',
              'preview-message__button--yellow': item.type === 'BF',
            }"
            type="button"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
</style>
